// BARatingMixin.ts

import { Component, Mixins } from 'vue-property-decorator';
import { ColorMixin, StringsMixin } from '@/mixins';
import { BARatingProfileModel } from '@/models/athlete/BARatingProfileModel'
import { BARatingFormulaFactor } from '@/models';
import { MissingDataBehaviour } from "@best-athletes/ba-types";

@Component
export class BARatingMixin extends Mixins(StringsMixin, ColorMixin) {
    FactorColor( obj: BARatingProfileModel, factor: BARatingFormulaFactor ): string {
        const data = this.FactorData(obj, factor);
        if( this.IsEmpty(data) ) return 'grey darken-2'
        if( data === 'na' ) return 'grey';

        const score = 100 * Number(data) / factor.max;
        return this.ScoutingScoreColor(score);
    }
    FactorTextColor( obj: BARatingProfileModel, factor: BARatingFormulaFactor ): string {
        const data = this.FactorData(obj, factor);
        if( this.IsEmpty(data) ) return 'grey darken-2'
        if( data === 'na' ) return 'grey';

        const score = 100 * Number(data) / factor.max;
        return this.ComplementaryTextColor(this.ScoutingScoreColorHex(score));
    }
    FactorMax( factor: BARatingFormulaFactor): string {
        const maxFactorScore = 100 * factor.a * factor.a + 100 * factor.b + factor.c;
        return maxFactorScore.toFixed(0);
    }

    normalizeKey(key: string): string {
        return key.replace(/[\s_\-]/g, '').toLowerCase(); // remove spaces, dashes, underscores; lowercase
    }
    getFuzzyKey(obj: Record<string, any>, targetKey: string): string {
        if( this.IsEmpty(obj) ) return undefined;
        if( this.IsEmpty(targetKey) ) return undefined;

        const normalizedTarget = this.normalizeKey(targetKey);
        for( const key in obj ) {
            if( this.normalizeKey(key) === normalizedTarget ) {
                return key;
            }
        }
        return '-none-';
    }
    getValueByFuzzyKey(obj: Record<string, any>, targetKey: string): any {
        if( this.IsEmpty(obj) ) return undefined;
        if( this.IsEmpty(targetKey) ) return undefined;

        const objKey = this.getFuzzyKey(obj, targetKey);
        if( this.IsNotEmpty(objKey) ) {
            return obj[objKey];
        }

        return undefined;
    }

    FactorData( obj: BARatingProfileModel, factor: BARatingFormulaFactor ): string {
        if( this.IsEmpty(obj) ) {
            if( factor.missingBehaviour === MissingDataBehaviour.default ) return factor.default.toFixed(0);
            return 'na';
        }

        const keys = factor.key.split('.');
        const data = this.getValueByFuzzyKey(obj, keys[0]);
        if( (keys.length === 1) && this.IsNotEmpty(data) ) {
            if( typeof(data) === 'string' ) return data;
            if( typeof(data) === 'boolean' ) return data? 'true':'false';
            if( typeof(data) === 'number' ) return (data < 25)? data.toFixed(1) : data.toFixed(0);
            if( data instanceof Date ) return this.formatDatePretty(data);
            if( data instanceof Array ) return data.toString();
            return typeof(data);
        }

        const subfactor = new BARatingFormulaFactor().load(factor);
        subfactor.key = keys.slice(1).join('.');
        return this.FactorData(data, subfactor)
    }
}